import { apiRequest } from './apiClient';

export const fetchGoalSettings = (userId) =>
	apiRequest('/api/v1/users/me/goal-settings', { userId });

export const deleteGoalSettings = (settingIds, userId) =>
	apiRequest('/api/v1/users/me/goal-settings', {
		method: 'DELETE',
		userId,
		body: { goal_setting_ids: settingIds },
	});

export const updateGoalPriorityRanks = (ranks, userId) =>
	apiRequest('/api/v1/users/me/goal-settings/priority-ranks', {
		method: 'PUT',
		userId,
		body: { ranks },
	});

export const saveGoalSettings = (goals, userId) =>
	apiRequest('/api/v1/users/me/goal-settings', {
		method: 'POST',
		userId,
		body: {
			goals: goals.map((goal) => ({
				term_id: parseInt(goal.id.replace('term_', ''), 10),
				priority_rank: 0,
			})),
		},
	});
